export const toCamelCase = (key: string): string => {
  return key.replace(/_([a-z])/g, (_, char) => char.toUpperCase())
}

export const toCapitalize = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
